import { render, staticRenderFns } from "./PaywallPreview.vue?vue&type=template&id=7643476c&scoped=true"
import script from "./PaywallPreview.vue?vue&type=script&lang=js"
export * from "./PaywallPreview.vue?vue&type=script&lang=js"
import style0 from "./PaywallPreview.vue?vue&type=style&index=0&id=7643476c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7643476c",
  null
  
)

export default component.exports